/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

type Props = {
  isNarrow?: boolean;
};

export const DetailsTitle = styled.div<Props>`
  min-width: ${({ isNarrow }) => (isNarrow ? "10rem" : "12rem")};
  word-break: break-all;
  color: ${theme.color.text.text02};
  padding: ${({ isNarrow }) => (isNarrow ? "0.3rem 0" : "initial")};
  text-transform: ${theme.typography.titleCase};
`;

export const DetailsLinkTitle = styled.div<Props>`
  min-width: ${({ isNarrow }) => (isNarrow ? "10rem" : "30rem")};
  word-break: break-all;
  color: ${theme.color.text.text02};
  padding: ${({ isNarrow }) => (isNarrow ? "0.3rem 0" : "initial")};
  text-transform: ${theme.typography.titleCase};
`;

export const StyledLinkSmall = styled(Link)`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.color.text.text01};
  text-decoration: underline;
  font-weight: ${theme.fontWeights.medium};
  margin: 0;
`;

export const StyledLink = styled(NavLink)`
  color: ${theme.color.text.text01};
  margin: 0;
  &:hover {
    text-decoration: none;
  }
  &.active {
    color: ${theme.color.interactive.link};
  }
`;

export const StyledOutsideLink = styled.a.attrs({
  target: "_blank",
  rel: "noreferrer",
})`
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
